import HttpClient from 'services/HttpClient';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBaseNewURL, getBaseURL } from 'services/getBaseURL';
import { getUserToken } from 'services/utils';

// Notice : Dont Remove Token for some APIs
const http = new HttpClient();
const newBaseUrl = getBaseNewURL().customize;

const initialState = {
	entekhabino: '',
	onboarding: true,
	loadingDetail: true,
	error: '',
	errorMassege: null,
	dataStores: {},
	storeDetailData: {},
	dataVipSrore: [],
	visitOnboaeding: true,
	storeBranches: [],
	relatedStores: [],
	storeCats: [],
	storesListByCats: [],
	totalStoresFilteredCount: 0,
	totalBranchesCount: 0,
	loading: {
		backdrop: false,
		form: false,
		skeleton: false,
		input: false,
	},
};

export const PostStore = createAsyncThunk('stores', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http
		.post(`/GetWidgets`, params, extraConfig)

		.then((res) => {
			return res.data;
		});
	return response;
});

// export const storeDetail = createAsyncThunk('storeDet', async (params) => {
// 	// Notice : Dont Remove Token
// 	const extraConfig = {
// 		headers: {
// 			'Authorization': guestToken,
// 		},
// 	};
// 	const param = { 'SupplierID': params.id };
// 	const response = await http.post(`GetSupplierInfo`, param, extraConfig).then((res) => res.data);
// 	return response;
// });

export const storeDetailBranches = createAsyncThunk('storeBranches', async (params) => {
	const parameters = {
		'Content': params.content,
		'supplierID': params.id,
		'CurrentProvinceIds': [],
		'CurrentCityIds': [],
		'PageIndex': 1,
		'PageSize': params.pageSize,
	};
	const response = await http
		.post(`https://api.kipaa.ir/interface/v1/KeepaApp/SupplierBranchFilter`, parameters)
		.then((res) => res.data);
	return response;
});

export const getRelateStores = createAsyncThunk('relatedStore', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http
		.post(`https://api.kipaa.ir/interface/v1/KeepaApp/GetRelatedSupplier`, params, extraConfig)
		.then((res) => res.data);
	return response;
});

export const storeCategories = createAsyncThunk('storeCategories', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http
		.post(`${newBaseUrl}KeepaApp/Categories`, params, extraConfig)
		.then((res) => res.data);
	return response;
});

const storeSlice = createSlice({
	name: 'store',
	initialState,
	reducers: {
		setDataVipStore(state, action) {
			state.dataVipSrore = action.payload;
		},
		setVisitOnBoarding(state, action) {
			state.visitOnboaeding = action.payload;
		},
	},

	extraReducers: (builder) => {
		builder
			.addCase(PostStore.pending, (state) => {
				state.loading.skeleton = true;
			})
			.addCase(PostStore.fulfilled, (state, action) => {
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.dataStores = Content.Zones.find((z) => z.Title === 'Center')?.Widgets;
				} else {
					state.errorMassege = Message;
				}
				// state.loading.skeleton = false;
			})
			.addCase(PostStore.rejected, (state) => {
				// state.loading.skeleton = false;
				state.errorMassege = 'خطا در بر قراری سرور';
			});

		// builder
		// 	.addCase(storeDetail.pending, (state) => {
		// 		state.loading.skeleton = true;
		// 	})
		// 	.addCase(storeDetail.fulfilled, (state, action) => {
		// 		const { Success, Message, Content } = action.payload;
		// 		if (Success) {
		// 			state.storeDetailData = { ...Content.SupplierInfo };
		// 		} else {
		// 			state.errorMassege = Message;
		// 		}
		// 		// state.loading.skeleton = false;
		// 	})
		// 	.addCase(storeDetail.rejected, (state) => {
		// 		// state.loading.skeleton = false;
		// 		state.errorMassege = 'خطا در بر قراری سرور';
		// 	});

		builder
			.addCase(storeDetailBranches.pending, () => {})
			.addCase(storeDetailBranches.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) {
					state.storeBranches = Content.SupplierBranch;
					state.totalBranchesCount = Content.Pagination?.Count;
				}
			})
			.addCase(storeDetailBranches.rejected, () => {});

		builder
			.addCase(getRelateStores.pending, () => {})
			.addCase(getRelateStores.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) state.relatedStores = Content.Supplier;
			})
			.addCase(getRelateStores.rejected, () => {});

		builder
			.addCase(storeCategories.pending, () => {})
			.addCase(storeCategories.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) state.storeCats = Content;
			})
			.addCase(storeCategories.rejected, () => {});

		// builder
		// 	.addCase(filterStoresByCat.pending, (state) => {
		// 		state.loading.skeleton = true;
		// 	})
		// 	.addCase(filterStoresByCat.fulfilled, (state, action) => {
		// 		const { Success, Content } = action.payload;
		// 		if (Success) {
		// 			state.totalStoresFilteredCount = Content?.Count;
		// 			state.storesListByCats = Content?.Suppliers;
		// 		}
		// 	})
		// 	.addCase(filterStoresByCat.rejected, () => {});
	},
});

export const { changedSheetStatus, setDataVipStore, setVisitOnBoarding } = storeSlice.actions;

export default storeSlice.reducer;
